import { t } from "../../../../utilities/translator";

type Props = {
  onShowAssistantClick: () => void,
  onShowFeedBuilderClick: () => void,
}

const WizardSelectorV2 = (props: Props) => {
  const {
    onShowAssistantClick,
    onShowFeedBuilderClick,
  } = props;

  return (
    <div className="flex flex-col gap-8">
      <div className="text-xl font-semibold text-center">{t('onboarding.assistant.wizardTypeTitle')}</div>
      <div className="flex flex-col gap-4">
        <div className="px-5 py-6 flex items-center justify-center gap-2 rounded-xl shadow-15 text-sm font-semibold" onClick={onShowAssistantClick}>
          <i className="ri-openai-line text-2xl" />
          <span>{t('onboarding.assistant.aiAssistant')}</span>
        </div>
        <div className="px-5 py-6 flex items-center justify-center gap-2 rounded-xl shadow-15 text-sm font-semibold" onClick={onShowFeedBuilderClick}>
          <i className="ri-hand text-2xl" />
          <span>{t('onboarding.assistant.feedBuilder')}</span>
        </div>
      </div>
    </div>
  )
}

export default WizardSelectorV2
